import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';

export const DependentMetaOverrideSet = buildFacetDesignOverride();
